import { BaseHealthCardParser } from "./BaseHealthCardParser";

export class OntarioHealdCardNumberParser extends BaseHealthCardParser {
    private OneDimensionRegex = /^\d{10}([A-Z]{2}){0,1}$/;
    private TwoDimensionRegex = [
        /^(@ON HC)(01\.10)([a-zA-Z0-9]{9})(?<HealthCareNumber>\d{10})(?<Name>.{28})(?<DateOfBirth>\d{8})(?<Sex>\d)(?<CardIssueDate>\d{8})(?<CardExpiryDate>\d{8})(?<LanguagePreference>\d{2})(?<CardVersionCode>[a-zA-Z0-9]{2})/,
    ];

    protected GetOneDimensionRegex(): RegExp {
        return this.OneDimensionRegex;
    }

    protected GetTwoDimensionRegex(): RegExp[] {
        return this.TwoDimensionRegex;
    }

    protected GetHealthCardNumber(result: RegExpMatchArray): string | null {
        let healthCardNumber = result.groups["HealthCareNumber"];
        const versionCode = result.groups["CardVersionCode"];

        if (!healthCardNumber)
            return null;

        if (healthCardNumber && versionCode) {
            healthCardNumber = `${healthCardNumber}-${versionCode}`;
        }

        return healthCardNumber;
    }
}



// WEBPACK FOOTER //
// ./src/services/HealthCardBarcodeScanParsers/OntarioHealthCardParser.ts